module["exports"] = ["Piazza", "Strada", "Via", "Borgo", "Contrada", "Rotonda", "Incrocio"];